import { ApiService } from '@/services';
import gql from 'graphql-tag';
import { StripeKey, Translation } from '@/types';

export class AppService extends ApiService {
  public async getStripeKey(): Promise<string> {
    const query = gql`
      query stripeKey {
        stripeKey {
          stripe_key
        }
      }
    `;
    return (await this.pubQuery<StripeKey>({ query }, 'stripeKey')).stripe_key;
  }
}

export const appSvc: AppService = new AppService();
